import Vue from 'vue'
import { urlHelpers } from '@/links'
import reloginCheck from '@/api/relogin'
import store from '@/store'

export function authRouteGuard(to, from, next) {
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let adminAccess = to.matched.some(record => record.meta.adminAccess)

  if (!requiresAuth && !adminAccess) {
    next()
    return
  }

  let toUrl = `${urlHelpers.originAndBase}${to.fullPath.slice(1)}`
  let unauthenticatedUrl = urlHelpers.signInReturn(toUrl)

  const checkAndHandleConditions = () => {
    // Conditions met to proceed
    if (
      store.getters['user/isSuperAdmin'] ||
      (!adminAccess && store.getters['user/isAuthenticated'])
    ) {
      next()
      return
    }

    // Conditions not met - handle based on which criteria wasn't met
    if (!store.getters['user/isAuthenticated']) {
      window.location.replace(unauthenticatedUrl)
      return
    }
    if (!store.getters['user/isSuperAdmin']) {
      alert('Not authorized')
    }
  }

  if (store.state.user.fetching) {
    store.commit('user/pushOnetimeCallback', checkAndHandleConditions)
    return
  }

  checkAndHandleConditions()
}

import LoginModal from '@/components/LoginModal'
import { getSSOProviderInfo } from '../api/auth'
let LoginModalCtor = Vue.extend(LoginModal)

export function reloginRouteGuard(router) {
  return async function reloginRouteGuard(to, from, next) {
    if (to.matched.some(record => record.meta.requiresReloginCheck)) {
      // Canceled route is either current route or home page
      let cancelledRoute = from.name ? false : { name: 'Home' }
      let reloginCheckDuration = 7

      // Do relogin check
      try {
        let returnUrl = `${urlHelpers.originAndBase}${to.fullPath.slice(1)}`
        let resp = await reloginCheck(reloginCheckDuration, { return_url: returnUrl })
        if (!resp.force_relogin) {
          next()
        } else {
          // Create and mount relogin modal
          let { email, sso_provider_ids } = store.state.user.user

          let ssoProviderInfo = {}
          try {
            ssoProviderInfo = await getSSOProviderInfo()
          } catch (err) {
            console.error('Error getting SSO provider info', err)
          }

          let loginModal = new LoginModalCtor({
            propsData: {
              email: email,
              ssoProviders: sso_provider_ids || [],
              ssoProviderInfo
            }
          })
          loginModal.$on('login-success', next.bind(this))
          loginModal.$on('login-dismissed', next.bind(this, cancelledRoute))

          // Tell loginModal where in the VDOM it is for
          // eventContext purposes
          loginModal.$parent = router.app.$children[0]

          // Actually mount the component into the DOM
          loginModal.$mount()
          router.app.$el.appendChild(loginModal.$el)
        }
      } catch (e) {
        // For now, if we fail to fetch relogin check, allow access to protected page
        console.error('Failed to complete relogin check', e)
        next()
      }
    } else {
      next()
    }
  }
}

export function betaRouteGuard(to, from, next) {

  if (!to.query || !to.query.beta) {
    next()
    return
  }

  const checkAndHandleConditions = () => {
    const hasAdminAccess = (
      store.getters['user/isSuperAdmin']
      || store.getters['user/isGoalbookBusinessUser']
    )
    if (hasAdminAccess) {
      store.dispatch('visibility/enableBetaMode', true)
    }
    next()
  }

  if (store.state.user.fetching) {
    store.commit('user/pushOnetimeCallback', checkAndHandleConditions)
    return
  }

  checkAndHandleConditions()
}